export const ASSETS_CONSTANTS = {
  UNASSIGNED: 'Unassigned',
  TABS: {
    HARDENING: 'hardening',
    APPLICATIONS: 'applications',
  },
} as const

export const APPLICATION_STATUS = {
  APPROVED: 'approved' as const,
  PENDING: 'pending' as const,
  DENIED: 'denied' as const,
} as const

export const MDM_STATUS = {
  MONITORED: 'monitored' as const,
  LOCKING: 'locking' as const,
  LOCKED: 'locked' as const,
  UNLOCKING: 'unlocking' as const,
  WIPE_REQUESTED: 'wipe_requested' as const,
  WIPING: 'wiping' as const,
  WIPED: 'wiped' as const,
} as const

export const OS = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
} as const

export const PLATFORM_TO_OS = {
  [OS.WINDOWS]: 'windows',
  [OS.MACOS]: 'macos',
  [OS.LINUX]: 'linux',
} as const

// OS to Platform mapping constants
export const OS_TO_PLATFORM = Object.fromEntries(
  Object.entries(PLATFORM_TO_OS).map(([platform, os]) => [os, platform]),
) as Record<(typeof PLATFORM_TO_OS)[keyof typeof PLATFORM_TO_OS], keyof typeof PLATFORM_TO_OS>
